export default __webpack_public_path__ + "c51f6587fc1da8262c8da7330e266948.svg";